import { render, staticRenderFns } from "./UbrTicketPro.vue?vue&type=template&id=1d293f44&scoped=true"
import script from "./UbrTicketPro.vue?vue&type=script&lang=js"
export * from "./UbrTicketPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d293f44",
  null
  
)

export default component.exports